import script from "./basicForm1.vue?vue&type=script&setup=true&lang=js"
export * from "./basicForm1.vue?vue&type=script&setup=true&lang=js"

import "./basicForm1.vue?vue&type=style&index=0&id=02cda1ef&lang=css"

const __exports__ = script;

export default __exports__